import { useEffect, useState } from "react";
import Menu from "../../Component/Menu/Menu";
import ModalCrearProducto from "./ModalCrearProducto";
import BarCard from "../../Component/header/BarCard";
import { DeleteProducto, GettaInveario } from "../../Servicios/Servicios";
import { useSpinner } from "../../Component/spinner/spinner";

function Inventario() {
  const [showModal, setShowModal] = useState(false);
  const [productos, setProductos] = useState([]);
  const spinner = useSpinner();
  useEffect(() => {
    // Aquí podrías cargar los productos del inventario si es necesario
    consultaInventario();
  }, []);

  const consultaInventario = async () => {
    spinner.show();
    try {
      const response = await GettaInveario()
      if (response.success) {
        setProductos(response.data.resultados);
        spinner.hide();
      } else {
        console.error("Error al obtener productos:", response.message);
        spinner.hide();
      }
      console.error("No se encontró el ID del establecimiento en localStorage.");
      return;
      
      // Aquí podrías hacer una llamada a la API para obtener los productos del inventario
    } catch (error) {
      console.error("Error al consultar el inventario:", error);
      spinner.hide();
    }
  }
  const eliminarProducto = async (id) => {

    const body= {
      id: id
    }
    console.log("ID del producto a eliminar:", body);
    const responseElminar = await DeleteProducto(body);
    if (responseElminar.success) {
      alert("Producto eliminado exitosamente");
      consultaInventario();
    } else {
      alert("Error al eliminar el producto:", responseElminar.message);
    }

  }
  return (
    <div >
      <div >
        <div className="flex flex-col p-8">
          <div className="flex justify-between items-center mb-8">
            <h2 className="text-xl text-white">Productos</h2>
            <button onClick={() => setShowModal(true)}  id="botonesEstandar">
              Crear producto
            </button>
          </div>
          {productos.length > 0 ? (
            <div className="overflow-x-auto" id="CuadrosEstandar">
              <table className="min-w-full rounded-lg shadow-md">
                <thead>
                  <tr className="text-left border-b">
                    <th className="p-4 text-white">Imagen</th>
                    <th className="p-4 text-white">Nombre del producto</th>
                    <th className="p-4 text-white">Categoría</th>
                    <th className="p-4 text-white">Precio</th>
                    <th className="p-4 text-white">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {productos.map((producto, index) => (
                    <tr key={index} className="border-b hover:bg-gray-50">
                      <td className="p-4">
                        <img
                          src={producto.imagen}
                          alt={producto.nombre}
                          className="w-12 h-12 object-cover rounded"
                        />
                      </td>
                      <td className="p-4 text-white">{producto.nombre}</td>
                      <td className="p-4 text-white">{producto.categoria}</td>
                      <td className="p-4 text-white">${producto.precio.toLocaleString()}</td>
                      <td className="p-4 flex gap-2">
                        <button className="p-2 text-white bg-gray-200 hover:bg-gray-300 rounded">
                          <i className="fas fa-edit text-black" />
                        </button>
                        <button className="p-2 text-white bg-red-100 hover:bg-red-200 rounded">
                          <i className="fas fa-trash text-red-500" onClick={() => eliminarProducto(producto.id)} />
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )  : (
          <div className="text-center text-gray-400 text-xs mt-32">
            No tienes ningún productos creados todavía
          </div>
          )}
        </div>
      </div>
      {showModal && <ModalCrearProducto onClose={() => setShowModal(false)} consultaInventario={consultaInventario} />}
    </div>
  );
}

export default Inventario;